// import { toast } from '@mx/vix';
/**
 * 分享图片
 * @param {*} channel
 * @param {*} callback
 */
export function shareImage(channel, callback) {
    if (!KNB) {
        return;
    }
    KNB.capture({
        sceneToken: 'jf-41a31fe97ae9d441',
        area: `#canvas`,
        returnType: 'localId',
        success: (res) => {
            KNB.shareImage({
                sceneToken: 'jf-41a31fe97ae9d441',
                thumbPic: '',
                picQuality: 60,
                image: res.localId,
                channel,
                success: () => {
                    callback && callback();
                },
                fail: (res) => {
                    if (res.errorCode === -500) {
                        KNB.toast({
                            content: '当前app不支持，请在其他app尝试'
                        });
                    } else if (res.errorCode === -502) {
                        KNB.toast({
                            content: '未安装微信，请安装后重试'
                        });
                    } else {
                        KNB.toast({
                            content: `分享失败，请稍后重试 code: ${res.errorCode}`
                        });
                    }
                }
            });
        },
        fail: (res) => {
            if (res.errorCode === -100) {
                KNB.toast({
                    content: '分享失败，没有相册权限，请到设置完成授权'
                });
            } else if (res.errorCode === 890) {
                KNB.toast({
                    content: '分享失败，请为美团/外卖App开启手机相册访问权限'
                });
            } else {
                KNB.toast({
                    content: `分享失败，请稍后重试 code: ${res.errorCode}`
                });
            }
        }
    });
}

// 分享h5
export function shareH5(title, desc, content, image, url, callback, channelV2s, wxurl) {
    if (KNB.env.isNative) {
        KNB.share({
            title,
            desc,
            content,
            image,
            url,
            channel: [KNB.share.WECHAT_FRIENDS, KNB.share.WECHAT_TIMELINE, KNB.share.WEIBO, KNB.share.COPY],
            channelV2s: channelV2s || [KNB.share.V2.WeixinFriends, KNB.share.V2.WeixinTimeline],
            success: function (res) {
                callback && callback(res);
            },
            fail: function (res) {
            }
        });
    } else {
        setTimeout(() => {
            wx.ready(() => {
                wx.updateAppMessageShareData({ 
                    title, // 分享标题
                    desc, // 分享描述
                    link: wxurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: image, // 分享图标
                    success: function () {
                        callback && callback();
                    }
                })
                wx.updateTimelineShareData({ 
                    title, // 分享标题
                    desc, // 分享描述
                    link: wxurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: image, // 分享图标
                    success: function () {
                        callback && callback();
                    }
                })
                wx.onMenuShareTimeline({
                    title, // 分享标题
                    link: wxurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: image, // 分享图标
                    success: function () {
                        callback && callback();
                    }
                });
                    
                wx.onMenuShareAppMessage({
                    title, // 分享标题
                    desc, // 分享描述
                    link: wxurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: image, // 分享图标
                    success: function () {
                        callback && callback();
                    }
                });
            })
        }, 1000)
    }
}

// 保存图片
export function saveImage(callback) {
    if (!KNB) {
        return;
    }
    KNB.capture({
        sceneToken: 'jf-41a31fe97ae9d441',
        area: `#canvas`,
        returnType: 'localId',
        success: () => {
            this.$toast.show('text', '图片已保存');
            callback && callback();
        },
        fail: (res) => {
            if (res.errorCode === 4) {
                return;
            }
            if (res.errorCode === -100) {
                KNB.toast({
                    content: '没有相册权限，请到设置完成授权'
                });
            } else {
                KNB.toast({
                    content: `保存失败，请稍后重试 code: ${res.errorCode}`
                });
            }
        }
    });
}
